import React, {useState} from "react";
import {cloneDeep} from "lodash";
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import Select from "react-select";
import {AREA_OPTIONS, PROVINCE_OPTIONS} from "@app/constants/Provinces";
import {LATEST_STABLE_LEVELS} from "@app/constants/Common";
import {JobStatusOptions} from "@pages/job/common/Constant";

const InitSearchConditions = {
    'employer_name': '',
    'job_title': '',
    'industry': '',
    'function': '',
    'job_level': '',
    'local_province': '',
    'local_area': '',
    'job_status': '',
}

const QuickSearchJob = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [searching, isSearching] = useState(false);

    const {onSearch} = props

    const onAddIndustryFunctionItem = (fieldName, value) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(searchConditions[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            searchConditions[fieldName] = arr
            setSearchConditions({...searchConditions})
        }
    }

    const onRemoveIndustryFunctionItem = (fieldName, index) => {
        let arr = cloneDeep(searchConditions[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            searchConditions[fieldName] = arr
            setSearchConditions({...searchConditions})
        }
    }
    const onChangeSearchItem = (name, values) => {
        searchConditions[name] = values;
        setSearchConditions({...searchConditions});
    };

    const onSearchJobs = () => {
        return onSearch(searchConditions)
    }

    const onClearSearchCondition = () => {
        setSearchConditions(cloneDeep(InitSearchConditions));
    }
    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">Search</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools">
                    <button
                        type='button'
                        className='btn btn-default mr-3'
                        onClick={() => onClearSearchCondition()}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => onSearchJobs()}
                        disabled={searching}
                    >
                        {searching ? 'Searching...' : 'Search'}
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div className={"row"}>
                    <div className='col-sm-3'>
                        <div className='form-group'>
                            <label className={'w-100'}>Tên Employer</label>
                            <input type='text' className='form-control' placeholder='Tên Employer'
                                   value={searchConditions.employer_name}
                                   name={'employer_name'}
                                   onChange={event => onChangeSearchItem('employer_name', event.target.value)}/>
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <div className='form-group'>
                            <label className={'w-100'}>Job Title</label>
                            <input type='text' className='form-control' placeholder='Job title'
                                   value={searchConditions.job_title}
                                   name={'job_title'}
                                   onChange={event => onChangeSearchItem('job_title', event.target.value)}/>
                        </div>
                    </div>

                    <div className='col-sm-3'>
                        <label className={'w-100'}>Job Industry</label>
                        <div style={{width: '100%'}}>
                            <ReactChipInput
                                classes={`class1 class2 w-100`}
                                chips={searchConditions.industry ? searchConditions.industry : []}
                                onSubmit={value => onAddIndustryFunctionItem('industry', value)}
                                onRemove={index => onRemoveIndustryFunctionItem('industry', index)}
                            />
                        </div>
                    </div>

                    <div className='col-sm-3'>
                        <label className={'w-100'}>Job Function</label>
                        <div style={{width: '100%'}}>
                            <ReactChipInput
                                classes={`class1 class2 w-100`}
                                chips={searchConditions.function ? searchConditions.function : []}
                                onSubmit={value => onAddIndustryFunctionItem('function', value)}
                                onRemove={index => onRemoveIndustryFunctionItem('function', index)}
                            />
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <label className={'w-100'}>Job Level</label>
                        <div style={{width: '100%'}}>
                            <select className={`form-control`}
                                    value={searchConditions.job_level}
                                    name={'job_level'}
                                    onChange={event => onChangeSearchItem("job_level", event.target.value)}>
                                {LATEST_STABLE_LEVELS.map((item, index) => {
                                    return <option value={item.toLowerCase()}>{item}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <label className={'w-100'}>Location (Tỉnh)</label>
                        <div style={{width: '100%'}}>
                            <Select options={PROVINCE_OPTIONS} isMulti
                                    value={searchConditions.local_province}
                                    onChange={value => {
                                        onChangeSearchItem('local_province', value);
                                    }}
                            />
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <label className={'w-100'}><b>Location Miền</b></label>
                        <div style={{width: '100%'}}>
                            <Select options={AREA_OPTIONS} isMulti
                                    value={searchConditions.local_area}
                                    onChange={value => {
                                        onChangeSearchItem('local_area', value);
                                    }}
                            />
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <label className={'w-100'}>Job Status</label>
                        <div style={{width: '100%'}}>
                            <Select options={JobStatusOptions}
                                    value={searchConditions.job_status}
                                    onChange={value => {
                                        onChangeSearchItem("job_status", value);
                                    }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuickSearchJob;
